import { ComponentStyleConfig } from "@chakra-ui/react";
import { fieldStyle } from "./input";

export const Textarea: ComponentStyleConfig = {
  variants: {
    outline: fieldStyle,
  },
  defaultProps: {
    variant: "outline",
  },
};

export const NumberInput: ComponentStyleConfig = {
  variants: {
    outline: {
      field: fieldStyle,
    },
  },
};

export const Card: ComponentStyleConfig = {
  baseStyle: {
    container: {
      bg: "white",
      borderRadius: "xl",
      boxShadow: "md",
    },
  },
};

export const Alert: ComponentStyleConfig = {
  baseStyle: {
    container: {
      borderRadius: "lg",
      fontSize: "sm",
    },
  },
};

export const Menu: ComponentStyleConfig = {
  baseStyle: {
    list: {
      borderWidth: 0,
      borderRadius: "xl",
      boxShadow: "lg",
      py: 2,
      px: 1,
    },
    item: {
      borderRadius: "md",
      fontSize: "sm",
      fontWeight: 500,
      color: "ink.DEFAULT",
      _hover: { bg: "surface.low", color: "brand.600" },
      _focus: { bg: "surface.low", color: "brand.600" },
    },
    divider: {
      borderColor: "line.soft",
      my: 1,
    },
  },
};

export const Drawer: ComponentStyleConfig = {
  baseStyle: {
    overlay: {
      bg: "rgba(20, 27, 43, 0.45)",
      backdropFilter: "blur(6px)",
    },
  },
};

export const Table: ComponentStyleConfig = {
  baseStyle: {
    th: {
      fontFamily: "heading",
      fontWeight: 700,
      letterSpacing: "0.04em",
      color: "ink.muted",
    },
  },
  variants: {
    simple: {
      th: { borderColor: "line.soft", bg: "surface.low" },
      td: { borderColor: "line.soft" },
    },
  },
};

export const Tabs: ComponentStyleConfig = {
  baseStyle: {
    tab: {
      fontFamily: "heading",
      fontWeight: 600,
    },
  },
  defaultProps: {
    colorScheme: "brand",
  },
};
